import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccessDeniedLogEntry, User, Role, Rule, RoleRight } from 'src/app/classes';
import { BackEndService } from 'src/app/backend-service';

@Component({
  selector: 'app-solve-access-denied-issue',
  templateUrl: './solve-access-denied-issue.component.html',
  styleUrls: ['./solve-access-denied-issue.component.css']
})
export class SolveAccessDeniedIssueComponent implements OnInit {

  _currentUser: User = null;
  roles: Role[] = [];
  roleRightsLoading: boolean = false;
  roleRightsLoaded: boolean = false;
  currentRules: Rule[] = [];

  set currentUser(user: User){
    this._currentUser = user;
  }

  get currentUser(): User {
    return this._currentUser;
  }

  get currentUsersRoles(): Role[] {
    if(this.currentUser && this.roles.length > 0) return this.roles.filter(x => this.currentUser.roleIds.includes(x.id));
    return [];
  }

  constructor(
    private backEndService: BackEndService,
    public dialogRef: MatDialogRef<SolveAccessDeniedIssueComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AccessDeniedLogEntry
  ) {

  }

  allIssuesSolved(): boolean {
    for(let rule of this.currentRules) {
      let rulePermitted = this.ruleIsPermittedSomehow(rule.rulecode);
      if(rule.rulecode == "edit_datasets") {
        if(rulePermitted) return true;
      }
      else if(!rulePermitted) return false;
    }
    return true;
  }

  loadRolesRights(): boolean {
    if(this.roleRightsLoading) return;
    this.roleRightsLoading = true;
    for(let role of this.currentUsersRoles) this.backEndService.get("api/role-right/" + role.id).subscribe((roleRights: RoleRight[]) => {
      role.rolerights = roleRights;
      this.roleRightsLoaded = true;
    });
  }

  ngOnInit() {
    this.backEndService.get("api/account/byusername/" + this.data.logusername).subscribe((user: User) => {
      this.currentUser = user;
      if(this.rolesAreLoaded()) this.loadRolesRights();
    });
    this.backEndService.get("api/role").subscribe((roles: Role[]) => {
      this.roles = roles;
      if(this.userIsLoaded()) this.loadRolesRights();
    });
    if(this.data.logrules){
      let rules = this.data.logrules.split(",");
      for(let ruleCode of rules) this.backEndService.get("api/rule/bycode/" + ruleCode).subscribe((rule: Rule) => {
        this.currentRules.push(rule);
      });
    }
  }

  userIsLoaded(): boolean {
    if(this.currentUser == null) return false;
    return true;
  }

  removeLogEntry(){
    this.dialogRef.close({ "removeLogEntry": this.data });
  }

  get requiredRules(): string[] {
    if(this.data && this.data.logrules) return this.data.logrules.split(",");
    return [];
  }

  roleIsAllowedTo(role: Role, ruleCode: string): boolean {
    let rule = this.currentRules.find(x => x.rulecode == ruleCode);
    if(rule) if(role.rolerights) if(typeof(role.rolerights.find(x => x.ruleid == rule.ruleid && x.value)) != "undefined") return true;
    return false;
  }

  rolesAreLoaded(): boolean {
    if(this.roles.length == 0) return false;
    return true;
  }

  ruleIsPermittedSomehow(rule: string): boolean {
    for(let role of this.currentUsersRoles) if(this.roleIsAllowedTo(role, rule)) return true;
    return false;
  }

  setRoleRight(event, role: Role, ruleCode: string){
    let rule = this.currentRules.find(x => x.rulecode == ruleCode);
    if(rule){
      if(event.checked){
        this.backEndService.get("api/role-right/permit/" + role.id + "/" + rule.ruleid).subscribe((created: RoleRight) => {
          var right = this.currentUsersRoles.find(x => x.id == role.id).rolerights.find(x => x.roleid == role.id && x.ruleid == rule.ruleid);
          if(right) right.value = true;
          else this.currentUsersRoles.find(x => x.id == role.id).rolerights.push(created);
        });
      } else {
        this.backEndService.get("api/role-right/refuse/" + role.id + "/" + rule.ruleid).subscribe((deleted: RoleRight) => {
          var right = this.currentUsersRoles.find(x => x.id == deleted.roleid).rolerights.find(x => x.ruleid == deleted.ruleid);
          if(right) right.value = false;
        });
      }
    }
  }
}
